export default "__VITE_ASSET__CIC2LevP__"